// Rollout switches of the Phase 4C screens. Read from `FEATURES` in config.json; a missing key means OFF,
// so an older config file keeps every screen on its current behaviour. Turning a switch off restores the previous screen without a backend change.
import config from "../config.json";

export const FEATURE_NAMES = Object.freeze({
  PAGED_REPORTS: "PAGED_REPORTS", // 4C-4 report tables on summary / paged details / export / ids
  REPORT_ANALYSIS_WINDOW: "REPORT_ANALYSIS_WINDOW", // 4C-3 analysis screens on period windows
  TICKET_SUMMARY: "TICKET_SUMMARY", // 4C-2 ticket analytics chart from the month summary endpoint (incl. archived history)
  TICKET_CHAT_PAGING: "TICKET_CHAT_PAGING", // 4C-2 ticket chat in cursor pages with "load older" (rolled out independently of the chart)
  DASHBOARD_ALERT_COUNT: "DASHBOARD_ALERT_COUNT", // 4C-1 dashboard "Alerts" from the notification total
  MENU_HISTORY_PAGINATION: "MENU_HISTORY_PAGINATION", // 4C-5 menu history in pages with "load older"
});

export const isFeatureEnabled = (name) => Boolean(config.FEATURES && config.FEATURES[name] === true);
